/**
 * Design tokens — single source of truth for colors across Outlook + Gmail.
 *
 * Outlook: consume as hex (`PRIMARY_HEX`) in Tailwind `@theme` / inline styles.
 * Gmail: consume as RGB 0-1 object (`PRIMARY_RGB`) for Card Service button `color` field.
 */
export const PRIMARY_HEX = '#29443D';
export const PRIMARY_HOVER_HEX = '#1E332E';
export const PRIMARY_LIGHT_HEX = '#E6F2EF';
export const SECONDARY_HEX = '#EDFEB2';
export const SECONDARY_HOVER_HEX = '#DFF09E';
export const DARK_HEX = '#2B2B2B';
export const GRAY_HEX = '#B6B6B6';
export const BODY_HEX = '#333333';
export const ERROR_HEX = '#A4262C';
/**
 * Beta pill defaults (Outlook): the soft surface used for selected/secondary
 * panels and the body text colour of the line under the wordmark. Admin
 * overrides both with its sidebar theme variables.
 */
export const BETA_PILL_BG_HEX = PRIMARY_LIGHT_HEX;
export const BETA_PILL_FG_HEX = BODY_HEX;
/**
 * Convert a `#RRGGBB` hex string to the RGB 0-1 object form used by
 * Google Card Service `color` fields.
 */
export function hexToRgbFloat(hex) {
    const cleaned = hex.replace(/^#/, '');
    const r = Number.parseInt(cleaned.slice(0, 2), 16) / 255;
    const g = Number.parseInt(cleaned.slice(2, 4), 16) / 255;
    const b = Number.parseInt(cleaned.slice(4, 6), 16) / 255;
    return {
        red: Math.round(r * 1000) / 1000,
        green: Math.round(g * 1000) / 1000,
        blue: Math.round(b * 1000) / 1000,
    };
}
/** Pre-computed RGB-float form for Gmail Card Service `color` fields. */
export const PRIMARY_RGB = hexToRgbFloat(PRIMARY_HEX);
export const SECONDARY_RGB = hexToRgbFloat(SECONDARY_HEX);
/**
 * Public Sharefox wordmark (SVG) — used wherever SVG works
 * (Gmail Card Service image widgets, Outlook task pane React UI).
 */
export const SHAREFOX_LOGO_URL = 'https://sharefox.co/wp-content/uploads/2022/05/Sharefox_logo_dark.svg';
// The AIRA circle icon (Gmail cards, Outlook task pane) is self-hosted by
// each app instead of a single shared URL — see apps/outlook-addin/public/
// aira-logo-circle.svg and apps/gmail-addon/public/aira-logo-circle.svg,
// served at /assets/aira-logo-circle.svg by the Gmail BFF (server.ts
// logoUrl()) and createAppsScriptManifest.ts for the add-on manifest icon.
// Previously a single SHAREFOX_ICON_PNG_URL pointed at the aira-email Cloud
// Run service; that's a separate service from every consumer, so any outage
// there broke the logo everywhere. Self-hosting removes that failure mode.
//# sourceMappingURL=tokens.js.map